import { useSearchStore } from '../../stores/search-store.js';
import { useSearch } from '../../hooks/useSearch.js';

const SCRYFALL_PAGE_SIZE = 175;

export function Pagination() {
  const results = useSearchStore((s) => s.results);
  const currentPage = useSearchStore((s) => s.currentPage);
  const isLoading = useSearchStore((s) => s.isLoading);
  const { execute } = useSearch();

  if (!results || results.totalCards <= SCRYFALL_PAGE_SIZE) return null;

  const totalPages = Math.ceil(results.totalCards / SCRYFALL_PAGE_SIZE);
  const hasPrev = currentPage > 1;
  const hasNext = results.hasMore;

  const goTo = (page: number) => void execute(page);

  const btnBase =
    'px-3 py-1.5 text-xs font-medium rounded-lg transition-colors disabled:opacity-40 disabled:cursor-not-allowed';

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-gray-800">
      <button
        onClick={() => goTo(currentPage - 1)}
        disabled={!hasPrev || isLoading}
        className={`${btnBase} bg-gray-800 hover:bg-gray-700 text-gray-300`}
      >
        ← Prev
      </button>

      <span className="text-xs text-gray-500">
        Page {currentPage} of {totalPages}
        <span className="ml-1 text-gray-700">({results.totalCards.toLocaleString()} cards)</span>
      </span>

      <button
        onClick={() => goTo(currentPage + 1)}
        disabled={!hasNext || isLoading}
        className={`${btnBase} bg-gray-800 hover:bg-gray-700 text-gray-300`}
      >
        Next →
      </button>
    </div>
  );
}
